module.exports = __webpack_public_path__ + "img/icon_video_play.398744f0.png";